"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var STATUS = {
  PROCESS: 'process',
  FINISH: 'finish',
  WAIT: 'wait'
};
/**
 * This is a private component to build out the Steps component.
 */

var StepItem =
/*#__PURE__*/
function (_React$Component) {
  _inherits(StepItem, _React$Component);

  function StepItem() {
    _classCallCheck(this, StepItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(StepItem).apply(this, arguments));
  }

  _createClass(StepItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          hover = _this$props.hover,
          title = _this$props.title,
          titleSuffix = _this$props.titleSuffix,
          status = _this$props.status,
          stepNumber = _this$props.stepNumber,
          props = _objectWithoutProperties(_this$props, ["className", "hover", "title", "titleSuffix", "status", "stepNumber"]);

      var stepBadge = stepNumber;

      if (typeof stepNumber === 'number') {
        stepBadge = _react.default.createElement(_FlexLayout.default, {
          className: "step-number"
        }, stepNumber);
      }

      var styleProps = {
        'data-status': status,
        'data-hover': hover
      };
      return _react.default.createElement(_FlexLayout.default, _extends({
        className: (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), "-step-item")),
        alignItems: "center",
        itemSpacing: "15px"
      }, styleProps, props), stepBadge, _react.default.createElement(_FlexLayout.default, {
        alignItems: "center",
        itemSpacing: "10px"
      }, _react.default.createElement("span", null, title), titleSuffix));
    }
  }]);

  return StepItem;
}(_react.default.Component);

exports.default = StepItem;
StepItem.STATUS = STATUS;
StepItem.defaultProps = {
  status: STATUS.PROCESS,
  stepNumber: 1,
  hover: true
};
StepItem.propTyeps = {
  /**
   * status styling for the step.<br>
   * - process: to highlight the current active step<br>
   * - finish: to mark the step as finished
   * - waiting: to mark the step as waiting to be processed
   */
  status: _propTypes.default.oneOf([STATUS.PROCESS, STATUS.FINISH, STATUS.WAIT]),

  /**
   * This is the number displayed prefix to the title.
   * By default the component handle proper styling for
   * number type.  For other node type it is the
   * application job to style accordingly.
   */
  stepNumber: _propTypes.default.node,

  /**
   * Title of the item.  If this is a string the component
   * will handle the styling properly for the various statuses.
   * For other node type it is up to the application
   * to style it appropriately.
   * Note: This should be a single line of text.  If you need
   * to add more description text consider using titleSuffix with
   * StatusIcon with tooltip.
   */
  title: _propTypes.default.node.isRequired,

  /**
   * Optional element to be placed on right side of the title string.
   */
  titleSuffix: _propTypes.default.node,

  /**
   * True if styling react to hover else false.
   */
  hover: _propTypes.default.bool
};